import React from "react";
import { ConfigProvider, type ThemeConfig } from "antd";
import zhCN from "antd/es/locale/zh_CN";
import dayjs from "dayjs";
import "dayjs/locale/zh-cn";

const primaryColor = "#337ab7";
const fontFamily =
    '"Microsoft YaHei", "Segoe UI", "Lucida Grande", Helvetica, Arial, FreeSans, Arimo, "Droid Sans", "wenquanyi micro hei", "Hiragino Sans GB", "Hiragino Sans GB W3", FontAwesome, sans-serif';

export const antdLocale = zhCN;

dayjs.locale("zh-cn");

const antdTheme: ThemeConfig = {
    hashed: false,
    token: {
        colorPrimary: primaryColor,
        colorInfo: primaryColor,
        colorLink: primaryColor,
        colorLinkHover: "#5695c4",
        colorLinkActive: "#215991",
        colorPrimaryHover: "#5695c4",
        colorPrimaryActive: "#215991",
        borderRadius: 2,
        fontFamily,
        fontSize: 14,
        lineHeight: 1.5715,
        controlHeight: 32,
        controlInteractiveSize: 16,
        zIndexPopupBase: 1000,
        wireframe: true,
    },
    components: {
        Button: {
            contentFontSize: 14,
            contentFontSizeSM: 14,
            contentFontSizeLG: 16,
            contentLineHeight: 1.5715,
            contentLineHeightSM: 1.5715,
            contentLineHeightLG: 1.5715,
            fontWeight: 400,
            paddingInline: 15,
            paddingInlineSM: 7,
            paddingInlineLG: 15,
            primaryShadow: "none",
            defaultShadow: "none",
            dangerShadow: "none",
        },
        Form: {
            itemMarginBottom: 10,
            labelColor: "#000",
        },
        Table: {
            borderColor: "#f0f0f0",
            cellFontSize: 14,
            cellFontSizeMD: 14,
            cellFontSizeSM: 14,
            cellPaddingBlock: 16,
            cellPaddingInline: 16,
            cellPaddingBlockMD: 12,
            cellPaddingInlineMD: 8,
            cellPaddingBlockSM: 8,
            cellPaddingInlineSM: 8,
            headerBg: "#fafafa",
            headerBorderRadius: 0,
            headerColor: "rgba(0, 0, 0, 0.85)",
            headerSplitColor: "#f0f0f0",
            rowHoverBg: "#fafafa",
            rowSelectedBg: "#e9f3f7",
            rowSelectedHoverBg: "#dfeff5",
        },
        Tabs: {
            cardBg: "#fafafa",
            cardGutter: 2,
            cardHeight: 38,
            cardPadding: "8px 16px",
            itemActiveColor: primaryColor,
            itemHoverColor: primaryColor,
            itemSelectedColor: primaryColor,
        },
    },
};

export function setupAntdStaticTheme() {
    ConfigProvider.config({
        theme: antdTheme,
        holderRender: (children) =>
            React.createElement(ConfigProvider, { locale: antdLocale, theme: antdTheme }, children),
    });
}

export default antdTheme;
